module.exports = __webpack_public_path__ + "r-v3/img/control_participant.8921d923.svg";